import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuth";
import { BrandMark } from "@/components/BrandMark";
import { LayoutDashboard, Building2, LogOut } from "lucide-react";

export default function AdminLayout({ children, title, subtitle, actions }) {
  const { user, logout } = useAdminAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const items = [
    { to: "/admin", icon: LayoutDashboard, label: "Overview" },
    { to: "/admin/societies", icon: Building2, label: "Societies" },
  ];

  return (
    <div className="min-h-screen flex bg-sand-50 text-ink">
      <aside className="hidden lg:flex flex-col w-64 bg-sand-200 border-r border-stone-200">
        <div className="px-6 py-6"><Link to="/admin"><BrandMark variant="portal" size={40} /></Link></div>
        <nav className="px-3 py-2 flex-1">
          {items.map((it) => {
            const active = it.to === "/admin" ? loc.pathname === "/admin" : loc.pathname.startsWith(it.to);
            return (
              <Link key={it.to} to={it.to} data-testid={`sidenav-${it.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-[15px] font-medium transition-colors ${active ? "side-active text-ink" : "text-stone-600 hover:text-ink"}`}>
                <it.icon size={18} strokeWidth={1.5} /> {it.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-stone-300/60">
          <div className="text-xs text-stone-500">Signed in as</div>
          <div className="text-sm font-medium mt-0.5">{user?.email}</div>
          <button onClick={async () => { await logout(); nav("/admin/login"); }}
            data-testid="admin-logout"
            className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-full border border-stone-300 bg-white hover:bg-sand-100 px-4 py-2 text-sm">
            <LogOut size={14}/> Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <header className="border-b border-stone-200 bg-sand-50 sticky top-0 z-10">
          <div className="max-w-6xl mx-auto px-6 lg:px-10 py-6 flex items-start justify-between gap-6">
            <div>
              {subtitle && <div className="text-xs uppercase tracking-widest text-stone-500 font-semibold mb-1">{subtitle}</div>}
              <h1 className="editorial text-3xl lg:text-4xl leading-tight tracking-tight" data-testid="page-title">{title}</h1>
            </div>
            <div className="flex items-center gap-3">{actions}</div>
          </div>
        </header>
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-8">{children}</div>
      </main>
    </div>
  );
}
